// Original Password Validation from MAIS Account Tools

const {validations} = require('indicative')
const moment = require('moment')
const escapeRE = require('escape-string-regexp')

validations.password = (data, field, message, args, get) => {
   return new Promise((resolve, reject) => {
      const value = get(data, field)
      const dateofbirth = get(data, 'dateofbirth')
      const username = get(data, 'username')
      const names = get(data, 'names')
      // console.log('Password validate', data, field, message, args)

      let password = new Password(value)
      let response = password.validateSyntax({dateofbirth, username, names})
      if (response)
         reject(response)
      resolve('passed')
   })
}

// Sequences to check against
const patternChecks = [
   // {
   //    msg: 'Password must not include alphabetic character sequences of 3 or more characters (e.g. abc), either forward or backwards, in any combination of upper or lower case.',
   //    sequence: 'abcdefghijklmnopqrstuvwxyz',
   //    length: 3
   // },
   // {
   //    msg: 'Password must not include numeric character sequences of 3 or more characters (e.g. 123), either forward or backwards.',
   //    sequence: '01234567890',
   //    length: 3
   // },
   // {  // Keyboard
   //    msg: 'Password must not include keyboard character sequences of 3 or more alphabetic characters (e.g. qwerty), either forward or backwards, in any combination of upper or lower case.',
   //    sequence: ['qwertyuiop', 'asdfghjkl', 'zxcvbnm'],
   //    length: 3
   // },
   // {
   //    msg: 'Password must not include 6 or more sequential characters from your Murdoch Username, either forward or backwards.',
   //    sequence: (d) => d && d.username ? [d.username.replace(/\@.*$/,'')] : [],
   //    length: 6
   // },
   // {
   //    msg: 'Password must not include 3 or more sequential characters from any part of your name, either forward or backwards.',
   //    sequence: (d) => d && d.names ? [d.names, d.names.replace(/\s+/,'')] : [],
   //    length: 3
   // }
]

const specialChars = '@ # $ % ^ & * - _ ! + = [ ] { } | \\ : \' , . ? / ` ~ " ( ) ;'
const specialCharRE = new RegExp('['+escapeRE(specialChars.replace(/ /g,'')+' ')+']')
const excludedCharsRE = new RegExp('[^a-z0-9'+escapeRE(specialChars.replace(/ /g,'')+' ')+']', 'i')

class Password {
   constructor(password) {
      this.password = password
   }

   // Check Syntactical Password Requirements, returning an appropriate error reason if not valid
   validateSyntax(data) {
      let pwd = this.password || ''

      // Sequence Pattern Checks
      let pwdLower = pwd.toLowerCase()
      let pwdReverse = pwdLower.split('').reverse().join('')
      let match = patternChecks.find(pattern => {
         let seqs = pattern.sequence
         // If our Sequence is a Function, call it with our data (and Lowercaseize the result)
         if (seqs instanceof Function)
            seqs = seqs(data||{}).map(seq => seq.toLowerCase())
         // Make sure our sequence is an Array of patterns
         if (!Array.isArray(seqs))
            seqs = [seqs]

         // console.log('Sequence Check', pwdLower, pwdReverse, seqs)
         for (let i=0; i <= pwdLower.length - pattern.length; i++) {
            let pwdbit = pwdLower.slice(i, i+pattern.length)
            if (seqs.find(seq => seq.includes(pwdbit))) {
               // console.log('Match', pwdbit, seqs)
               return true
            }
            pwdbit = pwdReverse.slice(i, i+pattern.length)
            if (seqs.find(seq => seq.includes(pwdbit))) {
               // console.log('Reverse Match', pwdbit, seqs)
               return true
            }
         }
      })
      if (match)
         return match.msg

      if (pwdLower.match(new RegExp(data.username.replace(/\@.*$/, ''),'i')))
         return 'Password must not include your username.'

      if (data.names.split(/\s+/).filter(n => n.length >= 3).some(name => pwdLower.includes(name.toLowerCase())))
         return 'Password must not include any of your names.'

      // Date of Birth checks
/*      if (data && data.dateofbirth) {
         const sets = {
            D: ['D', 'DD'],
            M: ['M', 'MM', 'MMM'],
            Y: ['YY', 'YYYY']
         }
         const orders = ['DM', 'MD', 'Y']
         let combos = []
         orders.forEach((order) => {
            let [a, b, c] = order.split('').map(set => sets[set])
            a.forEach(x => b ? b.forEach(y => c ? c.forEach(z => combos.push(x + y + z)) : combos.push(x + y)) : combos.push(x))
         })
         let noDividers = pwd.replace(/[\/\\\-]/, '')
         let birthDate = moment(data.dateofbirth, 'DD/MM/YYYY')
// console.log({noDividers, birthDate, combos})
         if (combos.find(format => noDividers.includes(birthDate.format(format))))
            return 'Password must not include your date of birth'
      }*/

      // if (pwd.match(/(.).*\1.*\1.*\1/))
      //    return 'Password must not include any characters occurring more than 4 times.'
      if (pwd.length < 8 || pwd.length > 127)
         return 'Password must be between 8 and 127 characters'
      if (!pwd.match(/[A-Z]/))
         return 'Password must have at least one upper case alphabetic character'
      if (!pwd.match(/[a-z]/))
         return 'Password must have at least one lower case alphabetic character'
      if (!pwd.match(/[0-9]/))
         return 'Password must have at least one numeric digit'
      if (!pwd.match(specialCharRE))
         return 'Password must have at least one symbol character from the following: '+specialChars
      if (pwd.match(excludedCharsRE))
         return 'Password must only contain characters (excluding Unicode characters), numbers, and symbols'
   }
}

module.exports = Password
